import { render, staticRenderFns } from "./CategoryAuditLogs.vue?vue&type=template&id=39a6e5e5"
import script from "./CategoryAuditLogs.vue?vue&type=script&lang=ts"
export * from "./CategoryAuditLogs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports